import React, { useEffect, useState } from "react";
import ItemsCategoryTable from "./Components/DeparmentsTable";
import AddDepartments from "./Components/AddDepartments";
import { hasAddAccess } from "../../../../../Common/CheckAccess";
import CommonSidebarForm from '../../../../../Common/CommonSidebarForm';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST } from '../../../../../Utils/Constant';

const Departments = () => {
  const dispatch = useDispatch();
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [permissions, setPermissions] = useState([]);
  const [drawerDepartment, setDrawerDepartment] = useState(null);
  const sidebarRef = useRef();
  const [inventoryDrawerDepartment, setInventoryDrawerDepartment] = useState(null);
  const inventorySidebarRef = useRef();
  const departmentCategoryList = useSelector(state => state.department.departmentCategoryList);
  const [categoryOptions, setCategoryOptions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  useEffect(() => {
    // Update options when departmentCategoryList changes
    if (departmentCategoryList?.data?.data) {
      setCategoryOptions(
        departmentCategoryList.data.data.map(cat => ({
          label: cat.name,
          value: cat.id,
        }))
      );
    }
  }, [departmentCategoryList]);

  const handleOpenCategoryDrawer = (department) => {
    setDrawerDepartment(department);
    setTimeout(() => {
      sidebarRef.current?.openSidebar();
    }, 0);
  };

  const handleCategoryFormSubmit = (formData) => {
    // Use department_id as categoryId for add category
    dispatch({
      type: 'POST_DEPARTMENT_CATEGORY_REQUEST',
      payload: { body: { ...formData, department_id: drawerDepartment?.id } },
    });
    sidebarRef.current?.closeSidebar();
  };

  const handleCategoryFormClear = () => {
    setDrawerDepartment(null);
  };

  const handleOpenInventoryDrawer = (department) => {
    setInventoryDrawerDepartment(department);
    // Fetch categories for this department
    dispatch({
      type: GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST,
      payload: {
        body: { page: 1, limit: 100,name:"" },
        id: department.id,
      },
    });
    setTimeout(() => {
      inventorySidebarRef.current?.openSidebar();
    }, 0);
  };

  const handleInventoryFormSubmit = (formData) => {
    // Use both category_id (subCategoryId) and department_id for add inventory item
    dispatch({
      type: 'POST_DEPARTMENT_INVENTORY_REQUEST',
      payload: {
        body: {
          ...formData,
          category_id: formData.category_id, // from the form
          department_id: inventoryDrawerDepartment?.id, // always use inventoryDrawerDepartment
        },
      },
    });
    inventorySidebarRef.current?.closeSidebar();
  };

  const handleInventoryFormClear = () => {
    setInventoryDrawerDepartment(null);
  };

  const sidebarFields = [
    {
      name: 'department',
      label: 'Department',
      type: 'text',
      required: false,
      readOnly: true,
      value: drawerDepartment?.name || '',
    },
    {
      name: 'name',
      label: 'Category Name',
      type: 'text',
      required: true,
    },
    {
      name: 'description',
      label: 'Description',
      type: 'text',
      required: false,
    },
  ];

  const unitOptions = [
    // Mass
    { label: "Milligram (mg)", value: "Milligram (mg)" },
    { label: "Gram (g)",       value: "Gram (g)"       },
    { label: "Kilogram (kg)",  value: "Kilogram (kg)"  },
    { label: "Tonne (ton)",    value: "Tonne (ton)"    },
    { label: "Pound (lb)",     value: "Pound (lb)"     },
    { label: "Ounce (oz)",     value: "Ounce (oz)"     },
  
    // Volume
    { label: "Milliliter (ml)", value: "Milliliter (ml)" },
    { label: "Liter (l)",       value: "Liter (l)"       },
    { label: "Cup",             value: "Cup"             },
    { label: "Pint (pt)",       value: "Pint (pt)"       },
    { label: "Quart (qt)",      value: "Quart (qt)"      },
    { label: "Gallon (gal)",    value: "Gallon (gal)"    },
  
    // Length
    { label: "Millimeter (mm)",  value: "Millimeter (mm)"  },
    { label: "Centimeter (cm)",  value: "Centimeter (cm)"  },
    { label: "Meter (m)",        value: "Meter (m)"        },
    { label: "Inch",             value: "Inch"             },
    { label: "Foot (ft)",        value: "Foot (ft)"        },
    { label: "Yard (yd)",        value: "Yard (yd)"        },
  
    // Count / Items
    { label: "Pieces (pcs)", value: "Pieces (pcs)" },
    { label: "Box",          value: "Box"          },
    { label: "Packet",       value: "Packet"       },
    { label: "Set",          value: "Set"          },
    { label: "Roll",         value: "Roll"         },
    { label: "Dozen",        value: "Dozen"        },
    { label: "Bundle",       value: "Bundle"       },
    { label: "Unit",         value: "Unit"         },
  
    // Containers
    { label: "Bottle", value: "Bottle" },
    { label: "Jar",    value: "Jar"    },
    { label: "Can",    value: "Can"    },
    { label: "Bag",    value: "Bag"    },
    { label: "Drum",   value: "Drum"   },
    { label: "Barrel", value: "Barrel" },
  
    // Misc
    { label: "Sheet",  value: "Sheet"  },
    { label: "Tablet", value: "Tablet" },
    { label: "Tube",   value: "Tube"   },
    { label: "Strip",  value: "Strip"  },
    { label: "Sachet", value: "Sachet" },
  ];
  
  const inventorySidebarFields = [
    {
      name: 'department',
      label: 'Department',
      type: 'text',
      required: false,
      readOnly: true,
      value: inventoryDrawerDepartment?.name || '',
    },
    {
      name: 'category_id',
      label: 'Category',
      type: 'select',
      required: true,
      options: categoryOptions,
    },
    {
      name: 'name',
      label: 'Item Name',
      type: 'text',
      required: true,
    },
    {
      name: 'description',
      label: 'Description',
      type: 'text',
      required: false,
    },
    {
      name: 'quantity',
      label: 'Quantity',
      type: 'number',
      required: true,
    },
    {
      name: 'unit',
      label: 'Unit',
      type: 'select',
      required: true,
      options: unitOptions,
    },
    {
      name: 'cost_per_unit',
      label: 'Price - Per Unit',
      type: 'number',
      required: true,
    },
  ];

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Department List</h3>
              <div className="col-auto d-flex w-sm-100">
                {['admin','super_admin','restaurant_manager','inventory_manager'].includes(role) && (
                  <button
                    type="button"
                    className="btn btn-dark"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#add-department"
                    aria-controls="add-department"
                    onClick={() => setSelectedDepartment(null)}
                  >
                    Add Department
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <ItemsCategoryTable
                  setSelectedDepartment={setSelectedDepartment}
                  onOpenCategoryDrawer={handleOpenCategoryDrawer}
                  onOpenInventoryDrawer={handleOpenInventoryDrawer}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CommonSidebarForm
        ref={sidebarRef}
        id="add-category-sidebar"
        title="Add Category"
        initialValues={{ name: '', description: '', department: drawerDepartment?.name || '' }}
        fields={sidebarFields}
        onSubmit={handleCategoryFormSubmit}
        onClear={handleCategoryFormClear}
        selectedItem={null}
        permission='departments'
      />
      <CommonSidebarForm
        ref={inventorySidebarRef}
        id="add-inventory-sidebar"
        title="Add Inventory Item"
        initialValues={{ name: '', description: '', quantity: '', unit: '', cost_per_unit: '', department: inventoryDrawerDepartment?.name || '', category_id: '' }}
        fields={inventorySidebarFields}
        onSubmit={handleInventoryFormSubmit}
        onClear={handleInventoryFormClear}
        selectedItem={null}
        permission='departments'
      />
      <AddDepartments
        setSelectedDepartment={setSelectedDepartment}
        selectedDepartment={selectedDepartment}
      />
    </>
  );
};

export default Departments;
